export function byNumericId(a: string, b: string): number {
  const na = parseInt(a, 10);
  const nb = parseInt(b, 10);
  if (!isNaN(na) && !isNaN(nb)) return na - nb;
  return String(a).localeCompare(String(b));
}

export function idSetSorted(arr: string[]): string[] {
  return [...new Set(arr)].sort(byNumericId);
}
